import React from 'react';
import { connect } from "react-redux";
import {
    DefaultButton,
    DetailsList,
    Dialog,
    DialogFooter,
    DialogType,
    Spinner,
    SpinnerSize,
    TextField,
    MessageBar,
    MessageBarType,
    CheckboxVisibility,
    PrimaryButton,
} from 'office-ui-fabric-react';
import axios from 'axios';
import config from '../config';

const HorizontalLine = () => (
    <hr
        style={{
            margin: "20px 0px",
            border: "none",
            borderTop: "1px dashed",
            borderColor: "lightgray",
        }}
    />
);

export class HealthPlans extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            newplan: {
                name: ""
            },
            plans: [],
            hasMore: false,
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.setState({
            isLoading: true
        });
        axios.get(config.apiUrl + '/healthplan/list')
            .then(({ data }) => {
                this.setState({
                    plans: data,
                    isLoading: false,
                    error: false
                });
            })
            .catch((ex) => {
                this.setState({
                    isLoading: false,
                    error: true
                });
            });
    }

    render() {

        const { plans, isLoading, error, newplan, hasMore } = this.state;

        const numRows = plans.length;

        var processCollum = columns.find(e => e.key == 'delete');
        processCollum.onRender = (e) => {
            return <div>
                <button className="tbl-btn" onClick={() => this.showDelete(e)}>
                    <i className="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
                </button>
            </div>;
        }

        if (error) {
            return <div>
                <MessageBar messageBarType={MessageBarType.error}>
                    Load error
                </MessageBar>
            </div>
        }
        return (

            <div style={{ margin: 10 }}>
                <div style={{ marginBottom: 10 }}>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                        }}
                    >
                        {["admin", "manager"].includes(
                            this.props.auth.user.accountType
                        ) && (
                                <PrimaryButton onClick={() => this.showDialog()}>
                                    Add a plan
                                </PrimaryButton>
                            )}


                    </div>

                    {isLoading ?
                        <Spinner size={SpinnerSize.large} /> :


                        <DetailsList
                                items={plans}
                                columns={columns}
                                checkboxVisibility={CheckboxVisibility.hidden}
                                style={{ fontSize: 14 }}
                            />

                    }

                </div>
                <Dialog
                    isOpen={this.state.showDialog}
                    type={DialogType.normal}
                    onDismiss={() => this.closeDialog()}
                    title={this.state.isEditing ? "Edit" : "Add new plan"}
                    isBlocking={true}
                    containerClassName="relative-info"
                >
                    <div className="ms-Grid">
                        {["admin", "manager", "central-user"].includes(
                            _.get(this.props, "auth.user.accountType")
                        ) && (
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-u-md6">
                                        <TextField
                                            className="one-line-100"
                                            label="Name"
                                            value={newplan.name}
                                            onChanged={(v) => this.valueChange("name", v)}
                                            maxLength={100}
                                        />

                                    </div>
                                    <div className="ms-Grid-col ms-u-md6">

                                    </div>
                                </div>
                            )}
                        <HorizontalLine />
                    </div>
                    <DialogFooter>
                        <PrimaryButton
                            onClick={() => this.save(newplan)}

                        >
                            Save
                        </PrimaryButton>
                        <DefaultButton onClick={() => this.closeDialog()}>
                            Cancel
                        </DefaultButton>
                    </DialogFooter>
                </Dialog>
            </div>
        )
    }


    showDialog() {
        this.setState({
            showDialog: true,
            isEditing: false,
        });
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            newplan: {
                name: ""
            },
        });
    }

    save(data) {
        axios
            .post(`${config.apiUrl}/healthplan/update`, data)
            .then(({ data }) => {
                let plans = [];
                plans = plans.concat(this.state.plans);
                const i = plans.findIndex((e) => e._id == data._id);
                if (i >= 0) {
                    plans[i] = data;
                } else {
                    plans.push(data);

                }

                this.resetPageData(plans);
            })
            .catch((ex) => {
                console.error(ex);
                // alert('Error');
            });

    }

    resetPageData(plans) {
        this.setState({
            plans: plans && plans.length > 0 ? plans : [],
            showDialog: false,
            newplan: {
                name: ""
            },
        });
    }

    valueChange(key, v) {
        this.setState((prevState) => ({
          newplan: { ...(prevState.newplan || {}), [key]: v },
        }));
    }

    showDelete(e) {
        if (confirm('Do you want delete ' + e.name + "?")) {
            axios.post(config.apiUrl + '/healthplan/delete/' + e._id)
                .then(() => {
                    this.loadData();
                })
        }
    }

}

export default connect(state => ({
    auth: state.auth
}))(HealthPlans);

const columns = [
    {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 300,
        maxWidth: 300
    }, {
        key: 'delete',
        name: '',
        minWidth: 100,
        maxWidth: 100
    }
]




// WEBPACK FOOTER //
// ./client/components/HealthPlans.js